<template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-pencil</v-icon>
      <v-toolbar-title>Block Additional Description List</v-toolbar-title>
    </v-toolbar>
    <v-card-title>
      <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      <v-layout>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Additional Block
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-layout>
    </v-card-title>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        v-bind:options.sync="pagination"
        item-key="name"
        :loading="loading"
        :no-data-text="noDataText"
        :custom-filter="customSearch"
      >
        <template v-slot:item="row"
          ><tr>
            <td class="text-xs-left">{{ row.item.blkGrp }}</td>
            <td class="text-xs-left">{{ row.item.blksGrp1 }}</td>
            <td class="text-xs-left">{{ row.item.blksGrp2 }}</td>
            <td class="text-xs-left">{{ row.item.blk }}</td>
            <td class="text-xs-left">{{ row.item.blkDesc }}</td>
            <td class="text-xs-left">{{ row.item.seqNo }}</td>
            <td class="text-xs-left">{{ row.item.blkAddlDesc }}</td>
            <td class="table-action-header">
              <table-action
                :rowData="row"
                review
                @review="doAction('edit', row.item)"
                query
                @query="doAction('query', row.item)"
                remove
                @remove="doPromptRemove"
              ></table-action>
            </td></tr
        ></template>
      </v-data-table>
    </v-card>
    <confirm v-model="promptRemove" @ok="doRemove"> Please confirm deletion of this records. </confirm>
    <v-dialog v-model="blkAddlDescReview" width="800px" persistent>
      <blk-addl-desc-review :blkAddlDescForm="blkAddlDescForm" :seqNo="seqNo" :mode="mode" @close="doClose"></blk-addl-desc-review>
    </v-dialog>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import BlkAddlDescReview from './BlkAddlDescReview'

export default {
  props: {
    id: Object
  },
  data() {
    return {
      toogleArray: [false],
      headers: [
        { text: 'Block Group', align: 'left', value: 'blkGrp' },
        { text: 'Block Sub Group 1', align: 'left', value: 'blksGrp1' },
        { text: 'Block Sub Group 2', align: 'left', value: 'blksGrp2' },
        { text: 'Block', align: 'left', value: 'blk' },
        { text: 'Block Description', align: 'left', value: 'blkDesc' },
        { text: 'Sequence No.', align: 'left', value: 'seqNo' },
        { text: 'Block Details', align: 'left', value: 'blkAddlDesc' },
        TableConst.tableActionHeader
      ],
      blkAddlDescForm: {
        accmType: null,
        blkGrp: null,
        blkGrpDescS: null,
        blksGrp1: null,
        blksGrp1DescS: null,
        blksGrp2: null,
        blksGrp2DescS: null,
        blk: null,
        blkDesc: null,
        seqNo: null,
        blkAddlDesc: null,
        createdName: '',
        createdDate: null,
        modifiedName: '',
        modifiedDate: null
      },
      seqNo: 0,
      totalItems: 0,
      promptRemove: false,
      mode: '',
      blkAddlDescReview: false,
      selectedBlkAddlDesc: {},
      loading: false,
      accmTypeList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.blkParam.menu
    }
  },
  methods: {
    async doInit() {
      await this.initForm()
      const apiURI = this.menu.getBlkAddlDescList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.id)
          this.items = []
          this.seqNo = 0
          const { data } = result.data
          if (data) {
            data.map((blkAddlDesc) => {
              this.seqNo += 1
              const convertList = {
                accmType: blkAddlDesc.accmType,
                blkGrp: blkAddlDesc.blkGrp,
                blksGrp1: blkAddlDesc.blksGrp1,
                blksGrp2: blkAddlDesc.blksGrp2,
                blk: blkAddlDesc.blk,
                blkDesc: this.blkAddlDescForm.blkDesc,
                seqNo: blkAddlDesc.seqNo,
                blkAddlDesc: blkAddlDesc.blkAddlDesc
              }
              this.items.push(convertList)
            })
            this.seqNo += 1
          } else {
            this.seqNo = 1
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getAccmTypeList() {
      const apiURI = this.menu.getAccmTypeList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.accmTypeList = []
        if (data) {
          data.map((accmType) => {
            const convertList = {
              label: accmType.accmType + ' - ' + accmType.accmTypeDesc,
              value: accmType.accmType
            }
            this.accmTypeList.push(convertList)
          })
        }
      }
    },
    async initForm() {
      const apiURI = this.menu.doNewInit
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.id)
          const { data } = result.data
          if (data) {
            if (data.blkGrp !== null) {
              this.blkAddlDescForm.accmType = data.blkGrp.accmType
              this.blkAddlDescForm.blkGrp = data.blkGrp.blkGrp
              this.blkAddlDescForm.blkGrpDescS = data.blkGrp.blkGrpDescS
            }
            if (data.blk !== null) {
              this.blkAddlDescForm.blk = data.blk.blk
              this.blkAddlDescForm.blkDesc = data.blk.blkDesc
            }
            if (data.blkSubGrp1 !== null) {
              this.blkAddlDescForm.blksGrp1 = data.blkSubGrp1.blksGrp1
              this.blkAddlDescForm.blksGrp1DescS = data.blkSubGrp1.blksGrp1DescS
            }
            if (data.blkSubGrp2 !== null) {
              this.blkAddlDescForm.blksGrp2 = data.blkSubGrp2.blksGrp2
              this.blkAddlDescForm.blksGrp2DescS = data.blkSubGrp2.blksGrp2DescS
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doAction(mode, listData) {
      const apiURI = this.menu.getBlkAddlDesc
      if (apiURI) {
        const result = await this.$http.put(apiURI, listData)
        const { data } = result.data
        if (data) {
          this.blkAddlDescForm.seqNo = data.blkAddlDesc.seqNo
          this.blkAddlDescForm.blkAddlDesc = data.blkAddlDesc.blkAddlDesc
          this.blkAddlDescForm.createdName = data.blkAddlDesc.createdName
          this.blkAddlDescForm.createdDate = data.blkAddlDesc.createdDate
          this.blkAddlDescForm.modifiedName = data.blkAddlDesc.modifiedName
          this.blkAddlDescForm.modifiedDate = data.blkAddlDesc.modifiedDate

          this.mode = mode
          this.blkAddlDescReview = true
        }
      }
    },
    async doNew() {
      this.mode = 'new'
      this.blkAddlDescReview = true
    },
    doClose() {
      this.blkAddlDescReview = false
      this.doInit()
    },
    doPromptRemove(data) {
      this.resetMessages()
      this.selectedBlkAddlDesc = data.item
      this.promptRemove = true
    },
    async doRemove(data) {
      const apiURI = this.menu.deleteBlkAddlDesc
      if (apiURI) {
        const expand = this.selectedBlkAddlDesc
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
          })
          .catch((err) => {
            const { data } = err.response
            this.message(data)
          })
      }
    }
  },
  mounted() {
    this.doInit()
    this.getAccmTypeList()
  },
  components: {
    BlkAddlDescReview
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
